import React, { useState } from 'react';
import { Table, DatePicker, Button, Space, Tag, Skeleton } from 'antd';
import { DownloadOutlined, FilterOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const AttendanceReportTab = ({ employeeId }) => {
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'),
    dayjs().endOf('month')
  ]);
  const [loading, setLoading] = useState(false);

  // Sample data - replace with actual API call
  const attendanceData = [
    {
      id: 1,
      date: '2024-01-15',
      checkIn: '09:00 AM',
      checkOut: '05:30 PM',
      status: 'present',
      hoursWorked: '8.5',
      overtime: '0.5',
    },
    {
      id: 2,
      date: '2024-01-16',
      checkIn: '08:55 AM',
      checkOut: '05:15 PM',
      status: 'present',
      hoursWorked: '8.33',
      overtime: '0',
    },
    {
      id: 3,
      date: '2024-01-17',
      checkIn: '-',
      checkOut: '-',
      status: 'absent',
      hoursWorked: '0',
      overtime: '0',
    },
  ];

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (text) => dayjs(text).format('DD MMM YYYY'),
    },
    {
      title: 'Check In',
      dataIndex: 'checkIn',
      key: 'checkIn',
    },
    {
      title: 'Check Out',
      dataIndex: 'checkOut',
      key: 'checkOut',
    },
    {
      title: 'Hours Worked',
      dataIndex: 'hoursWorked',
      key: 'hoursWorked',
      render: (hours) => `${hours} hrs`,
    },
    {
      title: 'Overtime',
      dataIndex: 'overtime',
      key: 'overtime',
      render: (hours) => hours > 0 ? <span className="text-success">{hours} hrs</span> : '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => {
        const colors = {
          present: 'success',
          absent: 'error',
          leave: 'warning',
          halfday: 'processing',
        };
        return <Tag color={colors[status]}>{status.toUpperCase()}</Tag>;
      },
    },
  ];

  const handleFilter = () => {
    setLoading(true);
    // TODO: Implement API call with date range filter
    setTimeout(() => setLoading(false), 1000);
  };

  const handleExport = () => {
    // TODO: Implement export functionality
    console.log('Exporting attendance report...');
  };

  const summaryData = {
    totalDays: 22,
    present: 19,
    absent: 1,
    leaves: 2,
    totalHours: '152',
    overtime: '12',
  };

  if (!employeeId) {
    return null;
  }

  return (
    <div className="tab-pane fade" id="bank_statutory">
      <div className="card">
        <div className="card-body">
          <div className="row mb-4">
            <div className="col-md-12">
              <h3 className="card-title">Attendance Report</h3>
            </div>
          </div>

          {/* Filter Section */}
          <div className="row mb-4">
            <div className="col-md-8">
              <Space>
                <RangePicker
                  value={dateRange}
                  onChange={setDateRange}
                  format="DD MMM YYYY"
                />
                <Button
                  type="primary"
                  icon={<FilterOutlined />}
                  onClick={handleFilter}
                >
                  Filter
                </Button>
              </Space>
            </div>
            <div className="col-md-4 text-end">
              <Button
                icon={<DownloadOutlined />}
                onClick={handleExport}
              >
                Export Report
              </Button>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row mb-4">
            <div className="col-md-2">
              <div className="stats-info">
                <h6>Total Days</h6>
                <h4>{summaryData.totalDays}</h4>
              </div>
            </div>
            <div className="col-md-2">
              <div className="stats-info">
                <h6>Present</h6>
                <h4 className="text-success">{summaryData.present}</h4>
              </div>
            </div>
            <div className="col-md-2">
              <div className="stats-info">
                <h6>Absent</h6>
                <h4 className="text-danger">{summaryData.absent}</h4>
              </div>
            </div>
            <div className="col-md-2">
              <div className="stats-info">
                <h6>Leaves</h6>
                <h4 className="text-warning">{summaryData.leaves}</h4>
              </div>
            </div>
            <div className="col-md-2">
              <div className="stats-info">
                <h6>Total Hours</h6>
                <h4>{summaryData.totalHours} hrs</h4>
              </div>
            </div>
            <div className="col-md-2">
              <div className="stats-info">
                <h6>Overtime</h6>
                <h4 className="text-info">{summaryData.overtime} hrs</h4>
              </div>
            </div>
          </div>

          {/* Attendance Table */}
          <div className="table-responsive">
            {loading ? (
              <Skeleton active paragraph={{ rows: 6 }} />
            ) : (
              <Table
                columns={columns}
                dataSource={attendanceData}
                rowKey="id"
                pagination={{
                  pageSize: 10,
                  showSizeChanger: true,
                  showTotal: (total) => `Total ${total} records`,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceReportTab;
